module.exports = __webpack_public_path__ + "static/media/entrantes.dd91c569.jpg";